export default __webpack_public_path__ + "static/media/money3.058743b6.jpg";